import * as React from "react";
import { IconProps } from "../types";

const ChevronDownIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <g
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          stroke={color}
        >
          <polyline points="1.75 4.25 6 8.5 10.25 4.25" />
        </g>
      </svg>
    );
  },
);

export default ChevronDownIcon;
